import { render, staticRenderFns } from "./MsIcon.vue?vue&type=template&id=e93972a6&scoped=true"
import script from "./MsIcon.vue?vue&type=script&lang=js"
export * from "./MsIcon.vue?vue&type=script&lang=js"
import style0 from "./MsIcon.vue?vue&type=style&index=0&id=e93972a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93972a6",
  null
  
)

export default component.exports